<div class="checkbox-wrap" *ngIf="visible">
    <input type="checkbox" id="return-flight-{{uniqueId}}" [(ngModel)]="isSelected" />
    <label for="return-flight-{{uniqueId}}">{{ 'I choose the same options for return flight' | translate:'extras' }}</label>
  </div>